import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M8 21s-4-3-4-9 4-9 4-9", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M16 3s4 3 4 9-4 9-4 9", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Parentheses";
const Parentheses = memo(themed(Icon));
export {
  Parentheses
};
//# sourceMappingURL=parentheses.js.map
